import {
    Component,
    OnInit,
    inject,
    DestroyRef,
    signal,
    input
} from '@angular/core';
import { Item } from '../../models/hotels/Item';
import { AuthGuardService } from '../../services/auth-guard.service';
import { AuthService } from '../../services/auth.service';
import { Price } from '../../models/hotels/Price';
import { Partner } from '../../models/partner/IPartner';
import { Menu } from './Menu';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GlobalmenuService } from '@app/services/globalmenu.service';
export interface PathHistory {
    country: Item;
    region: Item;
    hotel: Item;
    flug: string;
    booking: Price;
}
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

    partner: Partner;

    menuloading = signal<boolean>(false);

    destroyRef = inject(DestroyRef);


    constructor(
        protected guardService: AuthGuardService,
        protected authService: AuthService,
        protected globalmenuService: GlobalmenuService,
        protected mymenu: Menu,
    ) { }

    ngOnInit(): void {
        this.initPartner();
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((obj) => {
            // console.log(obj)
            if (obj?.partnerid?.length > 0) {
                this.partner = obj;
                this.getDefaultmenu();
            } else {
                this.partner = null;
            }
        });
    }

    async getDefaultmenu() {
        const target = {
            partnerid: this.partner.partnerid
        }
        this.globalmenuService.requestnew(target, 'getdefaultmenu').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((res) => {
            // console.log(res)
            this.mymenu.setMenus(res);
            this.menuloading.set(false);
        });
    }
}
